import { Flexbox, LoadingIndicator } from '@doc/ui-components';
import type { FunctionComponent } from 'react';
import Logo from '@/assets/abb-logo.svg';

export const BackdropLoading: FunctionComponent = () => {
	return (
		<div className='fixed top-0 left-0 right-0 bottom-0 bg-white dark:bg-bg_dark z-99'>
			<Flexbox justify='center' items='center' className='h-full gap-2'>
				<LoadingIndicator sizing='large' color='primary' />
				<Logo />
			</Flexbox>
		</div>
	);
};
